/**
 * 节点元数据注册表
 */
export class NodeMetadataRegistry {
    static register(target, metadata) {
        this.metadataMap.set(metadata.implementationType, metadata);
        this.executorClassMap.set(target, metadata.implementationType);
        this.executorConstructors.set(metadata.implementationType, target);
    }
    static getMetadata(implementationType) {
        return this.metadataMap.get(implementationType);
    }
    static getAllMetadata() {
        return Array.from(this.metadataMap.values());
    }
    static getByCategory(category) {
        return this.getAllMetadata().filter(m => m.category === category);
    }
    static getByNodeType(nodeType) {
        return this.getAllMetadata().filter(m => m.nodeType === nodeType);
    }
    static getImplementationType(executorClass) {
        return this.executorClassMap.get(executorClass);
    }
    static getExecutorConstructor(implementationType) {
        return this.executorConstructors.get(implementationType);
    }
    static getAllExecutorConstructors() {
        return new Map(this.executorConstructors);
    }
}
NodeMetadataRegistry.metadataMap = new Map();
NodeMetadataRegistry.executorClassMap = new Map();
NodeMetadataRegistry.executorConstructors = new Map();
/**
 * 节点执行器元数据装饰器
 */
export function NodeExecutorMetadata(metadata) {
    return function (target) {
        NodeMetadataRegistry.register(target, metadata);
    };
}
//# sourceMappingURL=NodeMetadata.js.map